import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";
import isEqual from "lodash/isEqual";

import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductAddToCoart extends React.Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initButton = (preview, blockPreview = false) => {
    let { payload, parentID } = this.props;

    if (blockPreview || payload === null) {
      payload = this.props.options.payload;
      parentID = "root";
    }

    const {
      buttonAnimation,
      iconClass,
      useIcon,
      iconPosition,
      buttonFullWidth,
    } = payload.datas || { buttonAnimation: "" };

    let ATCbuttonLabel = payload.datas["ATCbuttonLabel"] || "";

    if (
      payload.datas &&
      payload.datas["ATCbuttonLabel_" + this.props.currentLang]
    )
      ATCbuttonLabel =
        payload.datas["ATCbuttonLabel_" + this.props.currentLang];

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "Button");
    const cssAlignment = generateStyle(payload, "alignment");
    if (parentID === "root" && !blockPreview)
      return (
        <Container fluid={payload.fullContainer}>
          {setOverLay(payload)}
          <Row>
            <Col xs={12} className="fullcol">
              <div style={cssAlignment}>
                <span
                  className={`atc-btn ${
                    buttonAnimation
                      ? buttonAnimation + " infinite-animation"
                      : ""
                  } ${buttonFullWidth ? "full-width" : ""}`}
                  style={cssSettings}
                >
                  {!preview && <div className="overlay"></div>}
                  <span style={cssSettingsText}>
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span className="left">
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span className="left">
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}

                    {ATCbuttonLabel || ""}

                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span className="right">
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span className="right">
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}
                  </span>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      );
    else
      return (
        <div style={cssAlignment}>
          {setOverLay(payload)}
          <span
            className={`atc-btn ${
              buttonAnimation ? buttonAnimation + " infinite-animation" : ""
            } ${buttonFullWidth ? "full-width" : ""}`}
            style={cssSettings}
          >
            {!preview && <div className="overlay"></div>}
            <span style={cssSettingsText}>
              {useIcon &&
                iconPosition !== "right" &&
                iconClass &&
                Array.isArray(iconClass) && (
                  <span className="left">
                    <FontAwesomeIcon icon={[iconClass[0], iconClass[1]]} />
                  </span>
                )}
              {useIcon &&
                iconPosition !== "right" &&
                iconClass &&
                !Array.isArray(iconClass) && (
                  <span className="left">
                    <FontAwesomeIcon
                      icon={["fas", iconClass.replace("fa-", "")]}
                    />
                  </span>
                )}

              {ATCbuttonLabel || ""}

              {useIcon &&
                iconPosition === "right" &&
                iconClass &&
                Array.isArray(iconClass) && (
                  <span className="right">
                    <FontAwesomeIcon icon={[iconClass[0], iconClass[1]]} />
                  </span>
                )}
              {useIcon &&
                iconPosition === "right" &&
                iconClass &&
                !Array.isArray(iconClass) && (
                  <span className="right">
                    <FontAwesomeIcon
                      icon={["fas", iconClass.replace("fa-", "")]}
                    />
                  </span>
                )}
            </span>
          </span>
        </div>
      );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initButton(false, true)) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initButton(true, false)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initButton()}
      </Draggable>
    );
  }
}

ProductAddToCoart.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductAddToCoart);
